import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import Select from "../../../../components/Select";

export default function Courses({ searchObject, onChange, t }) {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    CommonService.getAllCourses().then((data) => setCourses(data));
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Course")}</legend>{" "}
      <Select
        name="courseId"
        className="form-select fontsize-legend"
        onChange={onChange}
        value={searchObject.courseId || ""}
      >
        <option value=""></option>
        {courses.map((course) => (
          <option
            className="fontsize-legend"
            key={course.id}
            value={course.description}
          >
            {t(course.description)}
          </option>
        ))}
      </Select>
    </div>
  );
}
